import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'
export const SectionWrapper = styled(Flex)`
  width: 100%;
  height: 100vh;
  overflow: scroll;
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: none;
  }
`
export const PaddedDiv = styled(Flex)`
  padding: 20px 25px;
  gap: 25px;
`
export const DriveIDStyle = styled(Flex)`
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_SM};
  line-height: 21px;
  color: ${COLORS.GREY_T_20};
  text-transform: capitalize;
`

export const EmptyWrapper = styled(Flex)`
  margin: 50px 0px;
  margin: ${props => props?.isSpin && '102px 0px'};
`
export const DriveIDStyleAlignCenter = styled(Flex)`
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_SM};
  line-height: 21px;
  color: ${COLORS.GREY_T_20};
  text-transform: capitalize;
  align-items: center;
  justify-content: center;
  display: flex;
`